import classNames from 'classnames';
import React, { ReactChild } from 'react';
import { useSelector } from 'react-redux';

import { selectInTrimMode } from 'selectors/shareVideo';

import { useShouldShowWaveform } from './hooks';

import styles from './styles.module.less';

type Props = {
  children: ReactChild;
};

export const OverlayWrapper = (props: Props): JSX.Element => {
  const newExperience = useShouldShowWaveform();

  const isInTrimMode: boolean = useSelector(selectInTrimMode);

  const aboveSharePageOverlay = isInTrimMode && newExperience;

  return (
    <div
      className={classNames({
        [styles.aboveSharePageOverlay]: aboveSharePageOverlay,
      })}
    >
      {props.children}
    </div>
  );
};
